import { useEffect, useState } from "react";
import { fetchShopSettings } from "./api";
import CoffeeCheckoutFlow from "./components/shop/CoffeeCheckoutFlow";
import LandingNav from "./components/layout/LandingNav";
import SiteFooter from "./components/ui/SiteFooter";
import { translations } from "./translations";

function getCheckoutLang() {
  if (typeof window === "undefined") return "hu";
  const lang = new URLSearchParams(window.location.search).get("lang");
  return lang === "en" ? "en" : "hu";
}

function CoffeeCheckoutPage() {
  const [lang, setLang] = useState(getCheckoutLang);
  const [shop, setShop] = useState(null);
  const [loading, setLoading] = useState(true);
  const siteT = translations[lang];
  const t = siteT.checkout;

  useEffect(() => {
    document.title = `${t.orderTitle} — Mizu Brunch & Coffee`;
    document.documentElement.lang = lang;
  }, [lang, t.orderTitle]);

  function handleLangChange(nextLang) {
    setLang(nextLang);
    const url = new URL(window.location.href);
    url.searchParams.set("lang", nextLang);
    window.history.replaceState({}, "", url);
  }

  useEffect(() => {
    let cancelled = false;

    async function loadShop() {
      setLoading(true);
      try {
        const data = await fetchShopSettings();
        if (cancelled) return;

        const canBuy =
          data.coffeeEnabled && data.coffeePriceHuf >= 175 && data.shipping;
        if (!canBuy) {
          window.location.replace("/");
          return;
        }

        setShop(data);
      } catch {
        if (!cancelled) {
          window.location.replace("/");
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    loadShop();
    return () => {
      cancelled = true;
    };
  }, []);

  function handleSuccess() {
    window.location.href = `/checkout/confirm?status=success&lang=${lang}`;
  }

  return (
    <div className="landing checkout-page">
      <LandingNav
        lang={lang}
        onLangChange={handleLangChange}
        t={siteT}
        hrefPrefix="/"
      />

      <main className="checkout-page-main">
        {loading || !shop ? (
          <p className="checkout-page-loading">{t.loading}</p>
        ) : (
          <CoffeeCheckoutFlow shop={shop} t={t} lang={lang} onSuccess={handleSuccess} />
        )}
      </main>

      <SiteFooter t={siteT.visitUs} />
    </div>
  );
}

export default CoffeeCheckoutPage;
